module.exports = __webpack_public_path__ + "static/media/familiar-superior.2.c3d3755e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/superior-familiar/images/familiar-superior.2.jpg
// module id = 682
// module chunks = 0